import { useDispatch } from 'react-redux'
import { IPoolProps } from '../../types/reducerTypes'
import { IAdminContract } from '../useAdminContract'
import { IMasterRpcContract } from '../useMasterRpcContract'
import {
  addActiveListPools,
  addCompletedListPools,
  addUpcomingListPools,
  setSerialisedPools,
  setStatusLoading,
} from '../../modules/listPools/actions'
import { setOldPoolsAddress } from '../../modules/listPools/actions'
import { cmsApi } from '../../api'
import { fetchUpcomingPools, getDeployedPools } from '../../utils'
import { legacyPools } from '../../data/legacy-pools'
import { unwantedPoolAddresses } from '../../config'
import Big from 'big.js'

export interface IPoolsWorkingData {
  fetchPools: () => Promise<string[]>
  dispatchPoolsToStore: (
    type: 'labs' | 'launch',
  ) => Promise<{ [key: string]: any }>
}

export const formattedLegacyPools = legacyPools.map((pool: any) => {
  pool.privateTokenPrice = new Big(pool.privateTokenPrice)
  pool.totalSaleSupply = new Big(pool.totalSaleSupply)
  pool.cmsData = { ...pool.cmsDetails }
  pool.media = { ...pool.cmsDetails.media }
  const params = {
    decimals: '18',
    airdrop: new Big(0),
    escrowPercentage: new Big(0),
    poolSupplyCounted: new Big(0),
    publicTokenPrice: new Big(0),
    privateTokenPrice: new Big(0),
    totalSaleSupply: new Big(0),
  }
  pool.address = pool.cmsDetails.poolAddress.toLowerCase()
  pool.params = params
  pool.cmsDetails.isLegacyPool = true
  return pool
})

const usePoolsData = (
  master: IMasterRpcContract,
  admin: IAdminContract,
): IPoolsWorkingData => {
  const dispatch = useDispatch()

  async function fetchPools() {
    // return (await admin.getPools()) ?? []
    return []
  }

  async function dispatchPoolsToStore(type: 'labs' | 'launch') {
    try {
      dispatch(setStatusLoading(type, true))

      const arrayPoolsAddressUnfiltered = (await fetchPools()) ?? []

      const arrayPoolsAddress =
        arrayPoolsAddressUnfiltered
          ?.map((a: string) => a.toLowerCase())
          ?.filter((a: string) => !unwantedPoolAddresses.includes(a)) ?? []

      const arrayPoolsAddressCrmUpcomingUnfiltered: IPoolProps[] =
        (await fetchUpcomingPools(type)) ?? []

      const activePools = []
      const fundedPools = []

      const arrayPoolsAddressCrmUpcoming =
        arrayPoolsAddressCrmUpcomingUnfiltered
          .map((pool: any) => {
            pool.address = pool?.address?.toLowerCase() ?? '0x'
            return pool
          })
          .filter((pool: any) => {
            if (
              unwantedPoolAddresses
                .map((a) => a.toLowerCase())
                .includes(pool.address)
            )
              return false

            if (Object.keys(pool).length === 0) return false

            const { cmsData } = pool

            if (!cmsData) return false

            const { poolAddress, isDeployed, privateSale } = cmsData

            if (!!poolAddress && isDeployed) {
              if (!privateSale) return false
              const { start, end } = privateSale
              const now = new Date().getTime()
              const startDate = new Date(start).getTime()
              const endDate = new Date(end).getTime()
              if (now > startDate && now < endDate) {
                activePools.push(pool)
                return false
              }
              if (now > endDate) {
                fundedPools.push(pool)
                return false
              }
            }

            return true
          })

      const oldPoolsData: any[] = []

      dispatch(
        setOldPoolsAddress(type, [
          ...arrayPoolsAddressCrmUpcoming,
          ...oldPoolsData,
        ]),
      )

      dispatch(
        addActiveListPools(
          type,
          activePools.map((pool) => {
            pool.period = 'open'
            return pool
          }),
        ),
      )

      dispatch(
        addCompletedListPools(
          type,
          fundedPools.map((pool: any) => {
            pool.params = { ...pool }
            pool.params.cmsDetails = { ...pool.cmsData }
            return pool
          }),
        ),
      )

      dispatch(addUpcomingListPools(type, arrayPoolsAddressCrmUpcoming))

      const crmArrayData =
        arrayPoolsAddress?.length > 0
          ? await cmsApi
              .get('/pools')
              .then(({ data }) =>
                data.data.map(({ attributes }: any) => attributes),
              )
          : []

      const allDeployedPools = await getDeployedPools()

      const deployedPools = allDeployedPools
        .filter((pool: any) =>
          arrayPoolsAddress
            .map((add) => add?.toLowerCase())
            .includes(pool?.poolAddress?.toLowerCase()),
        )
        .filter(
          (pool: any) =>
            !unwantedPoolAddresses
              .map((a) => a.toLowerCase())
              .includes(pool?.poolAddress?.toLowerCase()),
        )

      const serialisedByPoolAddress: { [key: string]: any } = {}

      crmArrayData.forEach((pool: any) => {
        serialisedByPoolAddress[pool?.poolAddress] = pool
      })

      oldPoolsData.forEach((pool: any) => {
        serialisedByPoolAddress[pool?.poolAddress] = pool
      })

      arrayPoolsAddressCrmUpcoming.forEach((pool: any) => {
        serialisedByPoolAddress[pool?.poolAddress ?? pool?.address] =
          pool?.cmsData ?? pool
      })

      deployedPools.forEach((pool: any) => {
        serialisedByPoolAddress[pool?.poolAddress ?? pool?.address] = pool
      })

      // formattedLegacyPools.forEach((pool: any) => {
      //   serialisedByPoolAddress[pool?.poolAddress ?? pool?.address] =
      //     pool.cmsDetails
      // })

      arrayPoolsAddress
        .filter(
          (address) => !unwantedPoolAddresses.includes(address.toLowerCase()),
        )
        .filter((val) => val)

      dispatch(setSerialisedPools(type, serialisedByPoolAddress))
      dispatch(setStatusLoading(type, false))

      return serialisedByPoolAddress
    } catch (error) {
      console.error(error)
    }
  }

  return { fetchPools, dispatchPoolsToStore }
}

export default usePoolsData
